import mutations from './internalReferral.mutations'
import actions from './internalReferral.actions'
import getters from './internalReferral.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
